import { observer } from 'mobx-react-lite';
import { useResolve } from '../use';
import { TOKEN_OnboardingStore } from './OnboardingStore';

// The two seconds between scanning a QR and having a screen, and the case where those two seconds
// end badly. Nothing here shows a code, a key or a hash: the person is standing in front of the TV
// that has the code on it, and the only thing they can do is scan it again.

export const JoinView = observer(function JoinView() {
  const onboarding = useResolve(TOKEN_OnboardingStore);

  if (onboarding.phase === 'failed') {
    return (
      <Centered>
        <p role="alert" className="text-xl text-rose-300">
          {onboarding.lastError ?? 'Could not join.'}
        </p>
      </Centered>
    );
  }
  return <Centered>Joining…</Centered>;
});

// A join link with a part missing. Its own screen rather than a silent fallback, because a
// half-copied link is a thing a human did and the fix is to scan rather than to type.
export const BadJoinView = observer(function BadJoinView() {
  return (
    <Centered>
      <p role="alert" className="text-xl text-rose-300">
        That link is incomplete. Scan the QR code on the TV rather than typing the address.
      </p>
    </Centered>
  );
});

// Nothing scanned yet. The cold open of the app's own address, which on a grading day means
// somebody typed it in.
export const LandingView = observer(function LandingView() {
  return <Centered>Scan the code for your court on the equipment room TV.</Centered>;
});

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-1 items-center justify-center p-8 text-center text-lg text-neutral-400">
      {children}
    </div>
  );
}
